<template>
  <div
    @click="onOpen"
    :class="['app-down-btn',isDetail?'is-detail':'']"
    v-if="!device.desktop && !isHeroGame && !isHorizontal">
    <img src="./../../../assets/images/app_bottom_down.png" alt="">
  </div>
</template>

<script>

  export default {
    name: 'appDownBtn',
    mixins: [],
    props: {},
    model: {},
    components: {},
    data () {
      return {
        isDetail: false
      };
    },
    computed: {},
    methods: {
      onOpen () {
        if (this.device.isWeixin) {
          this.$message('请使用自带浏览器打开当前页面');
          return;
        }

        if (this.device.ios) {
          window.location.href = 'https://help.gamekee.com/app/down';
        } else if (this.device.android) {
          window.location.href = 'gkwiki://page';
          setTimeout(() => {
            window.location.href = 'https://help.gamekee.com/app/down';
          }, 1500);
        }
      },
      onRouteChange () {
        if (this.$route.name == 'wikiDetail') {
          this.isDetail = true;
        } else {
          this.isDetail = false;
        }
      }
    },
    watch: {
      $route: 'onRouteChange'
    },
    created () {
      this.onRouteChange();
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
  };
</script>

<style scoped lang="less">
.app-down-btn {
  position: fixed;
  bottom: 20px;
  left: 5%;
  width: 90%;
  z-index: 1000;
  display: block;

  &.is-detail {
    bottom: 70px;
  }

  img {
    width: 100%;
  }
}
</style>
